import { patientApi } from '@/api/PatientApi'
import { COMPLETED_FORMS_QUERY_KEY } from '@/api/hooks/useFetchCompletedForms'
import { PENDING_FORMS_QUERY_KEY } from '@/api/hooks/useFetchPendingForms'
import type { FormEntry } from '@/api/types/Forms'
import { useMutation, useQueryClient } from '@tanstack/react-query'

const useSubmitPendingForm = () => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: ({
			id,
			entries,
			definitionVersion,
		}: { id: number; entries: FormEntry[]; definitionVersion: number }) =>
			patientApi.submitPendingForm(id, entries, definitionVersion),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: PENDING_FORMS_QUERY_KEY })
			queryClient.invalidateQueries({ queryKey: COMPLETED_FORMS_QUERY_KEY })
		},
	})
}

export { useSubmitPendingForm }
